import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { createBroadcastView, deleteBroadcastView, getBroadcastDetail } from '~src/broadcasts/actions/BroadcastActions';
import { BroadcastButton } from '~src/broadcasts/components/BroadcastButton';
import { Loadable } from '~src/httpClient/utils/Loadable';
import { IBroadcastableItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { LayoutType } from '~src/spacesPlatform/state/LayoutType';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';
import { IViewInfo } from '~src/views/models/IViewInfo';

import { IBroadcastDetail } from '../models/IBroadcastContentInfo';


export interface VizViewerBroadcastButtonProps {
    readonly spaceInfo: SpaceInfo;
    readonly layoutType: LayoutType;
}

export interface BroadcastsPropsFromReduxState {
    readonly broadcastStatus: Loadable<boolean>;
    readonly broadcastDetail: Loadable<IBroadcastDetail>;
}

export interface BroadcastsPropsFromReduxDispatch {
    readonly createBroadcastView: (item: IBroadcastableItemInfo) => void;
    readonly deleteBroadcastView: (item: IBroadcastableItemInfo) => void;
    readonly getBroadcastDetail: (item: IBroadcastableItemInfo) => void;
}

export type BroadcastComponentProps = VizViewerBroadcastButtonProps & BroadcastsPropsFromReduxState & BroadcastsPropsFromReduxDispatch;

export class BroadcastComponent extends React.PureComponent<BroadcastComponentProps> {

    public render() {
        broadcastProps.onCreateBroadcast = this.onCreateBroadcast;
        broadcastProps.onDeleteBroadcast = this.onDeleteBroadcast;
        return (<BroadcastButton {...broadcastProps}
            broadcastStatus={this.props.broadcastStatus}
            broadcastDetail={this.props.broadcastDetail}
            viewName={this.props.spaceInfo.item.name}
        />);
    }

    public componentDidUpdate(prevProps: BroadcastComponentProps) {
        // fetch broadcast detail after detecting props changes because 
        // delays of responses of querying view context
        if (!_.isEqual(prevProps.spaceInfo, this.props.spaceInfo)
            && !_.isUndefined(this.props.spaceInfo.item.luid)) {
            const viewInfo: IViewInfo = this.props.spaceInfo.item as IViewInfo;
            this.props.getBroadcastDetail(viewInfo);
        }
    }

    private onCreateBroadcast = () => {
        const viewInfo: IViewInfo = this.props.spaceInfo.item as IViewInfo;
        this.props.createBroadcastView(viewInfo);
    };

    private onDeleteBroadcast = () => {
        const viewInfo: IViewInfo = this.props.spaceInfo.item as IViewInfo;
        this.props.deleteBroadcastView(viewInfo);
    };
}

const broadcastProps = {
    onCreateBroadcast: _.noop,
    onDeleteBroadcast: _.noop,
    getBroadcastDetail: _.noop,
};

const mapStateToProps: MapStateToProps<BroadcastsPropsFromReduxState> = (state: AppState) => ({
    broadcastStatus: state.broadcast.broadcastStatus,
    broadcastDetail: state.broadcast.broadcastDetail,
});
const mapDispatchToProps: MapDispatchToProps<BroadcastsPropsFromReduxDispatch> = (dispatch) => bindActionCreators({
    createBroadcastView: createBroadcastView,
    deleteBroadcastView: deleteBroadcastView,
    getBroadcastDetail: getBroadcastDetail,
}, dispatch);

export const ConnectedBroadcastButton: React.ComponentClass<VizViewerBroadcastButtonProps> =
    connect(mapStateToProps, mapDispatchToProps)(BroadcastComponent);